import { BlogSection } from "@/types/blog";

export const koerperPassiert: BlogSection = {
  id: "koerper-passiert",
  title: "Was im Körper wirklich passiert",
  content: `
    <h3>Der Vagusnerv als Dirigent der inneren Ruhe</h3>
    
    <p>Im Zentrum dieses Stopp-Signals steht der Vagusnerv, der Hauptnerv des Parasympathikus. Er zieht sich vom Hirnstamm bis in die Organe und steuert Herzschlag, Atmung, Verdauung und Entzündungsprozesse. Wenn der Körper eine Infektion erkennt, bremst der Vagus gezielt überschießende Immunreaktionen, um Energie zu sparen und Heilung zu fördern.</p>
    
    <p>Ruhe ist also keine Faulheit, sondern biologische Intelligenz in Aktion. Das Nervensystem wählt bewusst den Reparaturmodus.</p>
    
    <h3>Wenn Gedanken Entzündungen beeinflussen</h3>
    
    <p>Die Psychoneuroimmunologie zeigt: Emotionen, Gedanken und soziale Bindung beeinflussen direkt, wie das Immunsystem reagiert. Wer sich verbunden fühlt, senkt messbar Entzündungsmarker. Isolation erhöht sie.</p>
    
    <p>Das bedeutet konkret: Wenn wir unter Druck stehen, während der Körper Heilung einfordert, entsteht ein biologischer Konflikt. Stresshormone bremsen die Regeneration, obwohl das Immunsystem sie bräuchte.</p>
    
    <h3>Die Verbindung zwischen Stress und Immunsystem</h3>
    
    <p>Die Hypothalamus-Hypophysen-Nebennieren-Achse reguliert die Cortisolausschüttung. Kurzzeitig hilft Cortisol, Infektionen zu kontrollieren. Doch wenn Stress chronisch wird, durch Druck, Selbstanspruch oder unterdrückte Erschöpfung, kippt der Effekt: Die Zellen reagieren resistent, Entzündungen nehmen zu, das Immunsystem läuft heiß.</p>
    
    <p>In diesem Zustand sendet der Körper Signale wie Müdigkeit, Schmerzen oder Infekte. Nicht als Schwäche, sondern als Versuch, das Gleichgewicht wiederherzustellen. Krankheit wird zum Reset-Impuls des autonomen Systems.</p>
  `
};
